// To-dos ticked in their open card (Bastian, 2026-10-20): the moment plays in the card, which closes once it has, so
// the row it closes onto shows the tick and the strike as they are, without the ring pulsing a second time. The
// card adds the id and takes it out again once the to-do has stopped lingering.
export const tickedInCard = new Set<string>();
